var _rect, _rect2, _g, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 92,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 36,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69,36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-30,0 0,-5.7423716V5.7423716z",
    fill: "#fcd116"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3",
    transform: "rotate(67.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3",
    transform: "rotate(135)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 138,
    height: 20,
    fill: "#0072c6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V92H68",
    fill: "#ce1126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138,0V92H68",
    fill: "#ce1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/ag.9d1a151c1f01b33e68c5d8274f049c59.svg";
export { ForwardRef as ReactComponent };